import styled from '@emotion/styled'
import { H1 } from 'library/atoms/Typography'
import useLayout from 'state/useLayout'

export interface PageTitleProps {
  /**
   * This component can be used in two different locations, this prop will use the media
   * query to determine when they should be displayed.
   */
  location?: 'header' | 'outside-header'
}

/**
 * It renders on the <header /> for wide screens or outside it for narrow screens (mobile).
 */
const PageTitle = ({ location = 'header' }: PageTitleProps) => {
  const { header } = useLayout()

  if (!header?.pageTitle) return null

  return (
    <StyledH1 fontStyle="h3" color="secondary" location={location}>
      {header.pageTitle}
    </StyledH1>
  )
}

export default PageTitle

export const StyledH1 = styled(H1)<PageTitleProps>(({ theme, location }) =>
  location === 'header'
    ? {
        display: 'none',
        [theme.mediaQueries.md]: {
          display: 'block'
        }
      }
    : {
        padding: theme.mixins.pxSpread([
          theme.space[5],
          theme.space[5],
          0,
          theme.space[5]
        ]),
        backgroundColor: theme.colors.white,
        [theme.mediaQueries.md]: {
          display: 'none'
        }
      }
)
